import { render, staticRenderFns } from "./BoCustomerIndex.vue?vue&type=template&id=32f778cd"
import script from "./BoCustomerIndex.vue?vue&type=script&lang=js"
export * from "./BoCustomerIndex.vue?vue&type=script&lang=js"
import style0 from "./BoCustomerIndex.vue?vue&type=style&index=0&id=32f778cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports